// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, type Composable, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { ActivityApiRespondToInvitationData, ActivityApiRespondToInvitationError, ActivityApiRespondToInvitationResponse, ActivityApiRespondToValidationData, ActivityApiRespondToValidationError, ActivityApiRespondToValidationResponse, CreateActivityParticipationData, CreateActivityParticipationError, CreateActivityParticipationResponse, CreateDryObservationData, CreateDryObservationError, CreateDryObservationResponse, CreateObservationData, CreateObservationError, CreateObservationResponse, CreateSiteData, CreateSiteError, CreateSiteResponse, DeleteProfileData, DeleteProfileResponse, GetArticleDetailData, GetArticleDetailError, GetArticleDetailResponse, GetArticleListData, GetArticleListError, GetArticleListResponse, GetArticleMapData, GetArticleMapError, GetArticleMapResponse, GetCaciFileData, GetCaciFileResponse, GetCertificatesData, GetCertificatesResponse, GetConfigData, GetConfigResponse, GetGlobalDataData, GetGlobalDataError, GetGlobalDataResponse, GetMemberListData, GetMemberListError, GetMemberListResponse, GetObservationBySiteGeoData, GetObservationBySiteGeoError, GetObservationBySiteGeoResponse, GetObservationListData, GetObservationListError, GetObservationListResponse, GetObservationSpecieListData, GetObservationSpecieListError, GetObservationSpecieListResponse, GetParticipationBySiteGeoData, GetParticipationBySiteGeoError, GetParticipationBySiteGeoResponse, GetParticipationDetailData, GetParticipationDetailError, GetParticipationDetailResponse, GetParticipationListData, GetParticipationListError, GetParticipationListResponse, GetProfileDetailData, GetProfileDetailResponse, GetSiteDetailData, GetSiteDetailResponse, GetSiteGeoData, GetSiteGeoError, GetSiteGeoResponse, GetSiteListData, GetSiteListError, GetSiteListResponse, GetSpecieDetailData, GetSpecieDetailResponse, GetSpecieListData, GetSpecieListError, GetSpecieListResponse, GetStatisticsData, GetStatisticsResponse, GetStatusData, GetStatusResponse, GetStructureDetailData, GetStructureDetailResponse, GetStructureGeoData, GetStructureGeoError, GetStructureGeoResponse, GetStructureListData, GetStructureListError, GetStructureListResponse, GetSupervisedParticipationListData, GetSupervisedParticipationListError, GetSupervisedParticipationListResponse, GetTaxonListData, GetTaxonListError, GetTaxonListResponse, GetTaxonTreeData, GetTaxonTreeError, GetTaxonTreeResponse, GetZoneHabitatListData, GetZoneHabitatListError, GetZoneHabitatListResponse, ParticipationInviteContactData, ParticipationInviteContactError, ParticipationInviteContactResponse, ParticipationInviteMemberData, ParticipationInviteMemberError, ParticipationInviteMemberResponse, ParticipationRemoveInvitationData, ParticipationRemoveInvitationError, ParticipationRemoveInvitationResponse, PullObservationListDetailedData, PullObservationListDetailedError, PullObservationListDetailedResponse, PullParticipationListDetailedData, PullParticipationListDetailedError, PullParticipationListDetailedResponse, PullSiteListDetailedData, PullSiteListDetailedError, PullSiteListDetailedResponse, PullSpecieListDetailedData, PullSpecieListDetailedError, PullSpecieListDetailedResponse, PullSpecieStatsData, PullSpecieStatsError, PullSpecieStatsResponse, PullStructureListDetailedData, PullStructureListDetailedError, PullStructureListDetailedResponse, PullSupervisedParticipationListDetailedData, PullSupervisedParticipationListDetailedError, PullSupervisedParticipationListDetailedResponse, RemoveActivityData, RemoveActivityError, RemoveActivityResponse, RemoveObservationData, RemoveObservationError, RemoveObservationImageData, RemoveObservationImageError, RemoveObservationImageResponse, RemoveObservationResponse, RemoveParticipationImageData, RemoveParticipationImageError, RemoveParticipationImageResponse, RemoveSiteImageData, RemoveSiteImageError, RemoveSiteImageResponse, SendParticipationForValidationData, SendParticipationForValidationError, SendParticipationForValidationResponse, UpdateActivityParticipationData, UpdateActivityParticipationError, UpdateActivityParticipationResponse, UpdateProfileData, UpdateProfileError, UpdateProfileResponse, UploadObservationImageData, UploadObservationImageError, UploadObservationImageResponse, UploadParticipationImageData, UploadParticipationImageError, UploadParticipationImageResponse, UploadProfileStampData, UploadProfileStampError, UploadProfileStampResponse, UploadSiteImageData, UploadSiteImageError, UploadSiteImageResponse } from './types.gen';

export type Options<TComposable extends Composable = '$fetch', TData extends TDataShape = TDataShape, ResT = unknown, DefaultT = undefined> = Options2<TComposable, TData, ResT, DefaultT> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * createActivityParticipation : Create a single activity, owned by the current logged user
 */
export const createActivityParticipation = <TComposable extends Composable = '$fetch', DefaultT extends CreateActivityParticipationResponse = CreateActivityParticipationResponse>(options: Options<TComposable, CreateActivityParticipationData, CreateActivityParticipationResponse, DefaultT>) => (options.client ?? client).post<TComposable, CreateActivityParticipationResponse | DefaultT, CreateActivityParticipationError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/activityParticipations/create',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * uploadParticipationImage : Upload a buffer image for a participation
 */
export const uploadParticipationImage = <TComposable extends Composable = '$fetch', DefaultT extends UploadParticipationImageResponse = UploadParticipationImageResponse>(options: Options<TComposable, UploadParticipationImageData, UploadParticipationImageResponse, DefaultT>) => (options.client ?? client).post<TComposable, UploadParticipationImageResponse | DefaultT, UploadParticipationImageError, DefaultT>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/participations/images/upload',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * removeParticipationImage : Remove a buffer image for a participation
 */
export const removeParticipationImage = <TComposable extends Composable = '$fetch', DefaultT extends RemoveParticipationImageResponse = RemoveParticipationImageResponse>(options: Options<TComposable, RemoveParticipationImageData, RemoveParticipationImageResponse, DefaultT>) => (options.client ?? client).post<TComposable, RemoveParticipationImageResponse | DefaultT, RemoveParticipationImageError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/participations/images/remove',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * updateActivityParticipation : Update a single activity, owned by the current logged user
 */
export const updateActivityParticipation = <TComposable extends Composable = '$fetch', DefaultT extends UpdateActivityParticipationResponse = UpdateActivityParticipationResponse>(options: Options<TComposable, UpdateActivityParticipationData, UpdateActivityParticipationResponse, DefaultT>) => (options.client ?? client).patch<TComposable, UpdateActivityParticipationResponse | DefaultT, UpdateActivityParticipationError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/activityParticipations/update',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * getParticipationList : List all participations for the logged member (paginated)
 */
export const getParticipationList = <TComposable extends Composable = '$fetch', DefaultT extends GetParticipationListResponse = GetParticipationListResponse>(options: Options<TComposable, GetParticipationListData, GetParticipationListResponse, DefaultT>) => (options.client ?? client).get<TComposable, GetParticipationListResponse | DefaultT, GetParticipationListError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/participations',
    ...options
});

/**
 * pullParticipationListDetailed : Incremental pull feed of the logged member's participations since a given cursor
 *
 * Returns records created/updated since `since` in `list`, the ids soft-deleted since `since`
 * in `deletedIds` (tombstones, so offline caches can drop ghosts), and a `serverTime` cursor
 * the client replays as the next `since` (avoids clock-skew from a client-derived cursor).
 */
export const pullParticipationListDetailed = <TComposable extends Composable = '$fetch', DefaultT extends PullParticipationListDetailedResponse = PullParticipationListDetailedResponse>(options: Options<TComposable, PullParticipationListDetailedData, PullParticipationListDetailedResponse, DefaultT>) => (options.client ?? client).get<TComposable, PullParticipationListDetailedResponse | DefaultT, PullParticipationListDetailedError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/participations/pull',
    ...options
});

/**
 * getSupervisedParticipationList : List all participations supervised by the logged member (paginated)
 */
export const getSupervisedParticipationList = <TComposable extends Composable = '$fetch', DefaultT extends GetSupervisedParticipationListResponse = GetSupervisedParticipationListResponse>(options: Options<TComposable, GetSupervisedParticipationListData, GetSupervisedParticipationListResponse, DefaultT>) => (options.client ?? client).get<TComposable, GetSupervisedParticipationListResponse | DefaultT, GetSupervisedParticipationListError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/supervisedParticipations',
    ...options
});

/**
 * pullSupervisedParticipationListDetailed : Incremental pull feed of the participations supervised by the logged member since a given cursor
 *
 * Returns records created/updated since `since` in `list`, the ids soft-deleted since `since`
 * in `deletedIds` (tombstones, so offline caches can drop ghosts), and a `serverTime` cursor
 * the client replays as the next `since` (avoids clock-skew from a client-derived cursor).
 */
export const pullSupervisedParticipationListDetailed = <TComposable extends Composable = '$fetch', DefaultT extends PullSupervisedParticipationListDetailedResponse = PullSupervisedParticipationListDetailedResponse>(options: Options<TComposable, PullSupervisedParticipationListDetailedData, PullSupervisedParticipationListDetailedResponse, DefaultT>) => (options.client ?? client).get<TComposable, PullSupervisedParticipationListDetailedResponse | DefaultT, PullSupervisedParticipationListDetailedError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/supervisedParticipations/pull',
    ...options
});

/**
 * createParticipationInvitation : Create a single empty participation for a given activity and member.
 * May trigger an invitation
 */
export const participationInviteMember = <TComposable extends Composable = '$fetch', DefaultT extends ParticipationInviteMemberResponse = ParticipationInviteMemberResponse>(options: Options<TComposable, ParticipationInviteMemberData, ParticipationInviteMemberResponse, DefaultT>) => (options.client ?? client).post<TComposable, ParticipationInviteMemberResponse | DefaultT, ParticipationInviteMemberError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/participations/invite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * createParticipationInvitationContact : Create a participation for a contact identified by email, creating a new member record
 */
export const participationInviteContact = <TComposable extends Composable = '$fetch', DefaultT extends ParticipationInviteContactResponse = ParticipationInviteContactResponse>(options: Options<TComposable, ParticipationInviteContactData, ParticipationInviteContactResponse, DefaultT>) => (options.client ?? client).post<TComposable, ParticipationInviteContactResponse | DefaultT, ParticipationInviteContactError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/participations/invite-contact',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * removeParticipationInvitation : Cancel a pending invitation by setting its status to Refused
 */
export const participationRemoveInvitation = <TComposable extends Composable = '$fetch', DefaultT extends ParticipationRemoveInvitationResponse = ParticipationRemoveInvitationResponse>(options: Options<TComposable, ParticipationRemoveInvitationData, ParticipationRemoveInvitationResponse, DefaultT>) => (options.client ?? client).post<TComposable, ParticipationRemoveInvitationResponse | DefaultT, ParticipationRemoveInvitationError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/participations/removeInvitation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * getParticipationBySiteGeo : Get the sites of the logged member's participations (GeoJSON)
 */
export const getParticipationBySiteGeo = <TComposable extends Composable = '$fetch', DefaultT extends GetParticipationBySiteGeoResponse = GetParticipationBySiteGeoResponse>(options: Options<TComposable, GetParticipationBySiteGeoData, GetParticipationBySiteGeoResponse, DefaultT>) => (options.client ?? client).get<TComposable, GetParticipationBySiteGeoResponse | DefaultT, GetParticipationBySiteGeoError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/participations/geo',
    ...options
});

/**
 * getParticipationDetail : Detail of one participation, including its activity
 */
export const getParticipationDetail = <TComposable extends Composable = '$fetch', DefaultT extends GetParticipationDetailResponse = GetParticipationDetailResponse>(options: Options<TComposable, GetParticipationDetailData, GetParticipationDetailResponse, DefaultT>) => (options.client ?? client).get<TComposable, GetParticipationDetailResponse | DefaultT, GetParticipationDetailError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/participations/{id}',
    ...options
});

/**
 * respondToInvitation : accept or refuse a participation invitation, owned by the current logged user
 */
export const activityApiRespondToInvitation = <TComposable extends Composable = '$fetch', DefaultT extends ActivityApiRespondToInvitationResponse = ActivityApiRespondToInvitationResponse>(options: Options<TComposable, ActivityApiRespondToInvitationData, ActivityApiRespondToInvitationResponse, DefaultT>) => (options.client ?? client).post<TComposable, ActivityApiRespondToInvitationResponse | DefaultT, ActivityApiRespondToInvitationError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/participations/respondToInvitation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * respondToValidation : accept or refuse a participation validation,
 */
export const activityApiRespondToValidation = <TComposable extends Composable = '$fetch', DefaultT extends ActivityApiRespondToValidationResponse = ActivityApiRespondToValidationResponse>(options: Options<TComposable, ActivityApiRespondToValidationData, ActivityApiRespondToValidationResponse, DefaultT>) => (options.client ?? client).post<TComposable, ActivityApiRespondToValidationResponse | DefaultT, ActivityApiRespondToValidationError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/participations/respondToValidation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * sendParticipationForValidation : Submit a participation for supervisor validation
 */
export const sendParticipationForValidation = <TComposable extends Composable = '$fetch', DefaultT extends SendParticipationForValidationResponse = SendParticipationForValidationResponse>(options: Options<TComposable, SendParticipationForValidationData, SendParticipationForValidationResponse, DefaultT>) => (options.client ?? client).post<TComposable, SendParticipationForValidationResponse | DefaultT, SendParticipationForValidationError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/participations/sendForValidation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * removeActivity : Remove an activity or the caller's participation in it
 */
export const removeActivity = <TComposable extends Composable = '$fetch', DefaultT extends RemoveActivityResponse = RemoveActivityResponse>(options: Options<TComposable, RemoveActivityData, RemoveActivityResponse, DefaultT>) => (options.client ?? client).post<TComposable, RemoveActivityResponse | DefaultT, RemoveActivityError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/activities/remove',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * getStatus : Get the application status for the calling client application
 *
 * Returns the active `ApplicationStatus` whose `origin` contains the `X-Client-Application`
 * header value, or `204 No Content` when none is active. `isBlocking` tells the client whether
 * to block usage or merely surface `message`.
 */
export const getStatus = <TComposable extends Composable = '$fetch', DefaultT extends GetStatusResponse = GetStatusResponse>(options: Options<TComposable, GetStatusData, GetStatusResponse, DefaultT>) => (options.client ?? client).get<TComposable, GetStatusResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/application/status',
    ...options
});

/**
 * getConfig : Get application configuration values
 */
export const getConfig = <TComposable extends Composable = '$fetch', DefaultT extends GetConfigResponse = GetConfigResponse>(options: Options<TComposable, GetConfigData, GetConfigResponse, DefaultT>) => (options.client ?? client).get<TComposable, GetConfigResponse | DefaultT, unknown, DefaultT>({ url: '/v1/{locale}/config', ...options });

/**
 * getArticleMap : Get all articles for a given context, keyed by their code
 */
export const getArticleMap = <TComposable extends Composable = '$fetch', DefaultT extends GetArticleMapResponse = GetArticleMapResponse>(options: Options<TComposable, GetArticleMapData, GetArticleMapResponse, DefaultT>) => (options.client ?? client).get<TComposable, GetArticleMapResponse | DefaultT, GetArticleMapError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/cms/articles/map',
    ...options
});

/**
 * getArticleList : Get all articles for a given context as a flat list
 */
export const getArticleList = <TComposable extends Composable = '$fetch', DefaultT extends GetArticleListResponse = GetArticleListResponse>(options: Options<TComposable, GetArticleListData, GetArticleListResponse, DefaultT>) => (options.client ?? client).get<TComposable, GetArticleListResponse | DefaultT, GetArticleListError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/cms/articles/list',
    ...options
});

/**
 * getArticleDetail : Detail of one article
 */
export const getArticleDetail = <TComposable extends Composable = '$fetch', DefaultT extends GetArticleDetailResponse = GetArticleDetailResponse>(options: Options<TComposable, GetArticleDetailData, GetArticleDetailResponse, DefaultT>) => (options.client ?? client).get<TComposable, GetArticleDetailResponse | DefaultT, GetArticleDetailError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/cms/articles/{code}',
    ...options
});

/**
 * list : Returns all reference data
 */
export const getGlobalData = <TComposable extends Composable = '$fetch', DefaultT extends GetGlobalDataResponse = GetGlobalDataResponse>(options: Options<TComposable, GetGlobalDataData, GetGlobalDataResponse, DefaultT>) => (options.client ?? client).get<TComposable, GetGlobalDataResponse | DefaultT, GetGlobalDataError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/globalData',
    ...options
});

/**
 * getMemberList : Get members by terms (paginated)
 */
export const getMemberList = <TComposable extends Composable = '$fetch', DefaultT extends GetMemberListResponse = GetMemberListResponse>(options: Options<TComposable, GetMemberListData, GetMemberListResponse, DefaultT>) => (options.client ?? client).get<TComposable, GetMemberListResponse | DefaultT, GetMemberListError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/members',
    ...options
});

/**
 * createObservation : Create a single observation
 */
export const createObservation = <TComposable extends Composable = '$fetch', DefaultT extends CreateObservationResponse = CreateObservationResponse>(options: Options<TComposable, CreateObservationData, CreateObservationResponse, DefaultT>) => (options.client ?? client).post<TComposable, CreateObservationResponse | DefaultT, CreateObservationError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/observations/create',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * createDryObservation : Create a single dry observation
 */
export const createDryObservation = <TComposable extends Composable = '$fetch', DefaultT extends CreateDryObservationResponse = CreateDryObservationResponse>(options: Options<TComposable, CreateDryObservationData, CreateDryObservationResponse, DefaultT>) => (options.client ?? client).post<TComposable, CreateDryObservationResponse | DefaultT, CreateDryObservationError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/observations/createDry',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * removeObservation : Soft-delete a single observation
 */
export const removeObservation = <TComposable extends Composable = '$fetch', DefaultT extends RemoveObservationResponse = RemoveObservationResponse>(options: Options<TComposable, RemoveObservationData, RemoveObservationResponse, DefaultT>) => (options.client ?? client).post<TComposable, RemoveObservationResponse | DefaultT, RemoveObservationError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/observations/remove',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * uploadObservationImage : Upload a buffer image for an observation
 */
export const uploadObservationImage = <TComposable extends Composable = '$fetch', DefaultT extends UploadObservationImageResponse = UploadObservationImageResponse>(options: Options<TComposable, UploadObservationImageData, UploadObservationImageResponse, DefaultT>) => (options.client ?? client).post<TComposable, UploadObservationImageResponse | DefaultT, UploadObservationImageError, DefaultT>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/observations/images/upload',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * removeObservationImage : Remove a buffer image for an observation
 */
export const removeObservationImage = <TComposable extends Composable = '$fetch', DefaultT extends RemoveObservationImageResponse = RemoveObservationImageResponse>(options: Options<TComposable, RemoveObservationImageData, RemoveObservationImageResponse, DefaultT>) => (options.client ?? client).post<TComposable, RemoveObservationImageResponse | DefaultT, RemoveObservationImageError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/observations/images/remove',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * getObservationList : List all observations (paginated)
 * for the logged member
 */
export const getObservationList = <TComposable extends Composable = '$fetch', DefaultT extends GetObservationListResponse = GetObservationListResponse>(options: Options<TComposable, GetObservationListData, GetObservationListResponse, DefaultT>) => (options.client ?? client).get<TComposable, GetObservationListResponse | DefaultT, GetObservationListError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/observations',
    ...options
});

/**
 * pullObservationListDetailed : Incremental pull feed of observations since a given cursor
 *
 * Returns records created/updated since `since` in `list`, the ids soft-deleted since `since`
 * in `deletedIds` (tombstones, so offline caches can drop ghosts), and a `serverTime` cursor
 * the client replays as the next `since` (avoids clock-skew from a client-derived cursor).
 *
 * Public by default (accepted observations only). With `mineOnly=true` and a valid token, it
 * returns the caller's own observations regardless of validation status.
 */
export const pullObservationListDetailed = <TComposable extends Composable = '$fetch', DefaultT extends PullObservationListDetailedResponse = PullObservationListDetailedResponse>(options: Options<TComposable, PullObservationListDetailedData, PullObservationListDetailedResponse, DefaultT>) => (options.client ?? client).get<TComposable, PullObservationListDetailedResponse | DefaultT, PullObservationListDetailedError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/observations/pull',
    ...options
});

/**
 * getObservationSpecieList : List species with observation statistics (paginated)
 */
export const getObservationSpecieList = <TComposable extends Composable = '$fetch', DefaultT extends GetObservationSpecieListResponse = GetObservationSpecieListResponse>(options: Options<TComposable, GetObservationSpecieListData, GetObservationSpecieListResponse, DefaultT>) => (options.client ?? client).get<TComposable, GetObservationSpecieListResponse | DefaultT, GetObservationSpecieListError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/observations/species',
    ...options
});

/**
 * getObservationBySiteGeo : List sites with observation statistics (GeoJSON)
 */
export const getObservationBySiteGeo = <TComposable extends Composable = '$fetch', DefaultT extends GetObservationBySiteGeoResponse = GetObservationBySiteGeoResponse>(options: Options<TComposable, GetObservationBySiteGeoData, GetObservationBySiteGeoResponse, DefaultT>) => (options.client ?? client).get<TComposable, GetObservationBySiteGeoResponse | DefaultT, GetObservationBySiteGeoError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/observations/sitesGeo',
    ...options
});

/**
 * getProfileDetail : Get detailed profile information for the logged member
 */
export const getProfileDetail = <TComposable extends Composable = '$fetch', DefaultT extends GetProfileDetailResponse = GetProfileDetailResponse>(options: Options<TComposable, GetProfileDetailData, GetProfileDetailResponse, DefaultT>) => (options.client ?? client).get<TComposable, GetProfileDetailResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/profile/detail',
    ...options
});

/**
 * getCertificates : Get certificates for the logged member
 */
export const getCertificates = <TComposable extends Composable = '$fetch', DefaultT extends GetCertificatesResponse = GetCertificatesResponse>(options: Options<TComposable, GetCertificatesData, GetCertificatesResponse, DefaultT>) => (options.client ?? client).get<TComposable, GetCertificatesResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/profile/certificates',
    ...options
});

/**
 * getStatistics : Get statistics for the logged member
 */
export const getStatistics = <TComposable extends Composable = '$fetch', DefaultT extends GetStatisticsResponse = GetStatisticsResponse>(options: Options<TComposable, GetStatisticsData, GetStatisticsResponse, DefaultT>) => (options.client ?? client).get<TComposable, GetStatisticsResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/profile/statistics',
    ...options
});

/**
 * getCaciFile : Get the CACI file for the logged member
 */
export const getCaciFile = <TComposable extends Composable = '$fetch', DefaultT extends GetCaciFileResponse = GetCaciFileResponse>(options: Options<TComposable, GetCaciFileData, GetCaciFileResponse, DefaultT>) => (options.client ?? client).get<TComposable, GetCaciFileResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/profile/caci',
    ...options
});

/**
 * updateProfile : Update scalar profile data for the logged member
 */
export const updateProfile = <TComposable extends Composable = '$fetch', DefaultT extends UpdateProfileResponse = UpdateProfileResponse>(options: Options<TComposable, UpdateProfileData, UpdateProfileResponse, DefaultT>) => (options.client ?? client).patch<TComposable, UpdateProfileResponse | DefaultT, UpdateProfileError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/profile/edit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * uploadProfileStamp : Upload the stamp image for the logged member
 */
export const uploadProfileStamp = <TComposable extends Composable = '$fetch', DefaultT extends UploadProfileStampResponse = UploadProfileStampResponse>(options: Options<TComposable, UploadProfileStampData, UploadProfileStampResponse, DefaultT>) => (options.client ?? client).post<TComposable, UploadProfileStampResponse | DefaultT, UploadProfileStampError, DefaultT>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/profile/stamp',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * deleteProfile : Delete the profile of the logged member
 */
export const deleteProfile = <TComposable extends Composable = '$fetch', DefaultT extends DeleteProfileResponse = DeleteProfileResponse>(options: Options<TComposable, DeleteProfileData, DeleteProfileResponse, DefaultT>) => (options.client ?? client).delete<TComposable, DeleteProfileResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/profile',
    ...options
});

/**
 * pullSiteListDetailed : Incremental pull feed of sites visible to the caller since a given cursor
 *
 * Returns records created/updated since `since` in `list`, the ids soft-deleted since `since`
 * in `deletedIds` (tombstones, so offline caches can drop ghosts), and a `serverTime` cursor
 * the client replays as the next `since` (avoids clock-skew from a client-derived cursor).
 *
 * Public by default (accepted sites only). With `mineOnly=true` and a valid token, it returns
 * the sites the caller has dived at (those holding one of their participations).
 */
export const pullSiteListDetailed = <TComposable extends Composable = '$fetch', DefaultT extends PullSiteListDetailedResponse = PullSiteListDetailedResponse>(options: Options<TComposable, PullSiteListDetailedData, PullSiteListDetailedResponse, DefaultT>) => (options.client ?? client).get<TComposable, PullSiteListDetailedResponse | DefaultT, PullSiteListDetailedError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/sites/pull',
    ...options
});

/**
 * getSiteList : Get all sites (paginated)
 */
export const getSiteList = <TComposable extends Composable = '$fetch', DefaultT extends GetSiteListResponse = GetSiteListResponse>(options: Options<TComposable, GetSiteListData, GetSiteListResponse, DefaultT>) => (options.client ?? client).get<TComposable, GetSiteListResponse | DefaultT, GetSiteListError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/sites',
    ...options
});

/**
 * getSiteGeo : Get all sites (GeoJSON)
 */
export const getSiteGeo = <TComposable extends Composable = '$fetch', DefaultT extends GetSiteGeoResponse = GetSiteGeoResponse>(options: Options<TComposable, GetSiteGeoData, GetSiteGeoResponse, DefaultT>) => (options.client ?? client).get<TComposable, GetSiteGeoResponse | DefaultT, GetSiteGeoError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/sites/geo',
    ...options
});

/**
 * getSiteDetail : Detail of one site
 */
export const getSiteDetail = <TComposable extends Composable = '$fetch', DefaultT extends GetSiteDetailResponse = GetSiteDetailResponse>(options: Options<TComposable, GetSiteDetailData, GetSiteDetailResponse, DefaultT>) => (options.client ?? client).get<TComposable, GetSiteDetailResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/sites/{id}',
    ...options
});

/**
 * createSite : Create a single site
 */
export const createSite = <TComposable extends Composable = '$fetch', DefaultT extends CreateSiteResponse = CreateSiteResponse>(options: Options<TComposable, CreateSiteData, CreateSiteResponse, DefaultT>) => (options.client ?? client).post<TComposable, CreateSiteResponse | DefaultT, CreateSiteError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/sites/create',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * uploadSiteImage : Upload a buffer image for a site
 */
export const uploadSiteImage = <TComposable extends Composable = '$fetch', DefaultT extends UploadSiteImageResponse = UploadSiteImageResponse>(options: Options<TComposable, UploadSiteImageData, UploadSiteImageResponse, DefaultT>) => (options.client ?? client).post<TComposable, UploadSiteImageResponse | DefaultT, UploadSiteImageError, DefaultT>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/sites/images/upload',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * removeSiteImage : Remove a buffer image for a site
 */
export const removeSiteImage = <TComposable extends Composable = '$fetch', DefaultT extends RemoveSiteImageResponse = RemoveSiteImageResponse>(options: Options<TComposable, RemoveSiteImageData, RemoveSiteImageResponse, DefaultT>) => (options.client ?? client).post<TComposable, RemoveSiteImageResponse | DefaultT, RemoveSiteImageError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/sites/images/remove',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * getSpecieList : Paginated list of species
 */
export const getSpecieList = <TComposable extends Composable = '$fetch', DefaultT extends GetSpecieListResponse = GetSpecieListResponse>(options: Options<TComposable, GetSpecieListData, GetSpecieListResponse, DefaultT>) => (options.client ?? client).get<TComposable, GetSpecieListResponse | DefaultT, GetSpecieListError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/species',
    ...options
});

/**
 * pullSpecieListDetailed : Incremental pull feed of species (detailed) since a given cursor
 *
 * Returns records created/updated since `since` in `list`, the ids soft-deleted since `since`
 * in `deletedIds` (tombstones, so offline caches can drop ghosts), and a `serverTime` cursor
 * the client replays as the next `since` (avoids clock-skew from a client-derived cursor).
 */
export const pullSpecieListDetailed = <TComposable extends Composable = '$fetch', DefaultT extends PullSpecieListDetailedResponse = PullSpecieListDetailedResponse>(options: Options<TComposable, PullSpecieListDetailedData, PullSpecieListDetailedResponse, DefaultT>) => (options.client ?? client).get<TComposable, PullSpecieListDetailedResponse | DefaultT, PullSpecieListDetailedError, DefaultT>({ url: '/v1/{locale}/species/pull', ...options });

/**
 * pullSpecieStats : Stats feed of observed species
 *
 * Per observed specie: observationCount, photoCount, siteCount and a weighted sites breakdown
 * ([{siteId, count, withPhotoCount}]) over public (accepted) observations — identical to
 * getObservationSpecieList without filter. Every siteId exists in /sites/pull.
 * Pass `since` to receive only species whose stats changed after that date (delta-sync).
 */
export const pullSpecieStats = <TComposable extends Composable = '$fetch', DefaultT extends PullSpecieStatsResponse = PullSpecieStatsResponse>(options: Options<TComposable, PullSpecieStatsData, PullSpecieStatsResponse, DefaultT>) => (options.client ?? client).get<TComposable, PullSpecieStatsResponse | DefaultT, PullSpecieStatsError, DefaultT>({ url: '/v1/{locale}/species/stats/pull', ...options });

/**
 * getSpecieDetail : Detail of one specie
 */
export const getSpecieDetail = <TComposable extends Composable = '$fetch', DefaultT extends GetSpecieDetailResponse = GetSpecieDetailResponse>(options: Options<TComposable, GetSpecieDetailData, GetSpecieDetailResponse, DefaultT>) => (options.client ?? client).get<TComposable, GetSpecieDetailResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/species/{id}',
    ...options
});

/**
 * getTaxonTree : Get all taxons as a tree
 */
export const getTaxonTree = <TComposable extends Composable = '$fetch', DefaultT extends GetTaxonTreeResponse = GetTaxonTreeResponse>(options: Options<TComposable, GetTaxonTreeData, GetTaxonTreeResponse, DefaultT>) => (options.client ?? client).get<TComposable, GetTaxonTreeResponse | DefaultT, GetTaxonTreeError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/taxons/tree',
    ...options
});

/**
 * getTaxonList : List taxons (id + name), optionally filtered by ids
 */
export const getTaxonList = <TComposable extends Composable = '$fetch', DefaultT extends GetTaxonListResponse = GetTaxonListResponse>(options: Options<TComposable, GetTaxonListData, GetTaxonListResponse, DefaultT>) => (options.client ?? client).get<TComposable, GetTaxonListResponse | DefaultT, GetTaxonListError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/taxons',
    ...options
});

/**
 * getZoneHabitatList : List all zone habitats
 */
export const getZoneHabitatList = <TComposable extends Composable = '$fetch', DefaultT extends GetZoneHabitatListResponse = GetZoneHabitatListResponse>(options: Options<TComposable, GetZoneHabitatListData, GetZoneHabitatListResponse, DefaultT>) => (options.client ?? client).get<TComposable, GetZoneHabitatListResponse | DefaultT, GetZoneHabitatListError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/zoneHabitats',
    ...options
});

/**
 * getStructureList : Get all structures (paginated)
 */
export const getStructureList = <TComposable extends Composable = '$fetch', DefaultT extends GetStructureListResponse = GetStructureListResponse>(options: Options<TComposable, GetStructureListData, GetStructureListResponse, DefaultT>) => (options.client ?? client).get<TComposable, GetStructureListResponse | DefaultT, GetStructureListError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/structures',
    ...options
});

/**
 * pullStructureListDetailed : Incremental pull feed of structures (detailed) since a given cursor
 *
 * Returns records created/updated since `since` in `list`, the ids soft-deleted since `since`
 * in `deletedIds` (tombstones, so offline caches can drop ghosts), and a `serverTime` cursor
 * the client replays as the next `since` (avoids clock-skew from a client-derived cursor).
 */
export const pullStructureListDetailed = <TComposable extends Composable = '$fetch', DefaultT extends PullStructureListDetailedResponse = PullStructureListDetailedResponse>(options: Options<TComposable, PullStructureListDetailedData, PullStructureListDetailedResponse, DefaultT>) => (options.client ?? client).get<TComposable, PullStructureListDetailedResponse | DefaultT, PullStructureListDetailedError, DefaultT>({ url: '/v1/{locale}/structures/pull', ...options });

/**
 * getStructureGeo : Get all structures (GeoJSON)
 */
export const getStructureGeo = <TComposable extends Composable = '$fetch', DefaultT extends GetStructureGeoResponse = GetStructureGeoResponse>(options: Options<TComposable, GetStructureGeoData, GetStructureGeoResponse, DefaultT>) => (options.client ?? client).get<TComposable, GetStructureGeoResponse | DefaultT, GetStructureGeoError, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/structures/geo',
    ...options
});

/**
 * getStructureDetail : Detail of one structure
 */
export const getStructureDetail = <TComposable extends Composable = '$fetch', DefaultT extends GetStructureDetailResponse = GetStructureDetailResponse>(options: Options<TComposable, GetStructureDetailData, GetStructureDetailResponse, DefaultT>) => (options.client ?? client).get<TComposable, GetStructureDetailResponse | DefaultT, unknown, DefaultT>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/{locale}/structures/{id}',
    ...options
});
